module.exports = __webpack_public_path__ + "static/media/brook-landing-marque-image-01.bbf8682e.jpg";